import { render, staticRenderFns } from "./app-link-fallback.vue?vue&type=template&id=0f271160"
import script from "./app-link-fallback.vue?vue&type=script&lang=ts"
export * from "./app-link-fallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports